<template>
  <div>
    <div class="site-header row">
      <div class="col-4"></div>
      <div class="col-4">
        <img src="../assets/tassyl9-grey.png" class="top-logo mt-4">
        <div class="tagline text-center">
          <p>Connecting you to your future.</p>
        </div>
      </div>
      <div class="col-4"></div>
    </div>
    <div class="row justify-content-center" id="select-instructions">
      <h1>SELECT A SCHOLARSHIP</h1>
    </div>
    <div v-on:click="reroute('/nff_ncr/scholar_athlete_scholarship/information')">
      <div class="scholCard">
        <a><img src="../assets/nff.jpg" class="p-2 orgImg" alt="..."></a>
        <h3 class="text-center">National Football Foundation, National Capitol Region</h3>
      </div>
    </div>
    <br/>
    <div v-on:click="reroute('/piedmont_charitable_foundation/pcf_scholarship/information')">
      <div class="scholCard">
        <a><img src="../assets/piedmont.png" class="p-2 orgImg" alt="..."></a>
        <h3 class="text-center">Piedmont Charitable Foundation, PCF Scholarship</h3>
      </div>
    </div>
    <br/>
    <div v-on:click="reroute('/naval_intelligence_professionals/nip_scholarship/information')">
      <div class="scholCard">
        <a><img src="../assets/nip.png" class="p-2 orgImg" alt="..."></a>
        <h3 class="text-center">Naval Intelligence Professionals, NIP Scholarship</h3>
      </div>
    </div>
    <br/>
  </div>
</template>

<script>
import axios from '../auth.js'
export default {
  mounted(){
    if (this.$route.query.notify) {
      this.$toasted.success(this.$route.query.notify,
        {
          position: "bottom-right",
          duration: 10000
        })
    }
    axios.post(
      `${process.env.VUE_APP_ENDPOINT}/users/sign_in/`
    )
    .then(res =>{
      localStorage.setItem("loggedIn", true)
      this.$store.commit('login', true)
      this.$store.commit('setUserName', res.data.first_name)
    })
    .catch(e => {
      this.message = e.response.data.error
      localStorage.setItem("loggedIn", false)
      this.$store.commit('login', false)
      this.$store.commit('setUserName', null)
      //this.$store.commit('setProfileData', {})
    })
  },
  methods:{
    reroute(path){
      this.$store.commit('setAfterLoginPath', path)
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss">

.scholCard:hover {
  filter: brightness(80%);
}

.scholCard {
  width: 50%;
  margin-right: auto;
  margin-left: auto;
  background-color: white;
  padding-top: 1em;
  padding-bottom: 1em;
  cursor: pointer;
}

.orgImg {
  max-height: 150px;
  width: auto;
  height: auto;
  margin-right: auto;
  margin-left: auto;
  display: block;
  margin-bottom: .5em;
}

#select-instructions {
  padding-top: 3em;
  padding-bottom: 3em;
}

</style>
